import { c as _c } from "react/compiler-runtime";
import i18n from 'i18next';
import { copyToClipboard, DataStatus, Dialog, DialogProps, TextInput } from 'platform/components';
import { useEffect } from 'react';
import { suffixTestId, TestIdProps } from 'shared/web';
import { SharePresetStateEnum } from '../../../../../../types/SharePresetState';
import { useSharePreset } from '../../hooks/useSharePreset';
const SHARE_PRESET_DIALOG_DELAY = 2000;
type SharePresetDialogProps = Omit<DialogProps, 'children' | 'isOpen'> & TestIdProps;
export function SharePresetDialog(props) {
  const $ = _c(31);
  const {
    shareUrl,
    sharePresetState,
    sharePreset,
    onClose
  } = useSharePreset(props.onClose);
  let t0;
  if ($[0] !== shareUrl) {
    t0 = () => {
      shareUrl && copyToClipboard(shareUrl);
    };
    $[0] = shareUrl;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onCopyToClipboard = t0;
  let t1;
  if ($[2] !== sharePreset) {
    t1 = () => {
      const timeoutId = setTimeout(() => sharePreset(), SHARE_PRESET_DIALOG_DELAY);
      return () => clearTimeout(timeoutId);
    };
    $[2] = sharePreset;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = i18n.t("page.datagrid.labels.sharePresetDialogTitle");
    t4 = i18n.t("general.actions.close");
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  let t5;
  if ($[7] !== props) {
    t5 = suffixTestId("close", props);
    $[7] = props;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== onClose || $[10] !== t5) {
    t6 = [{
      title: t4,
      variant: "primary",
      onClick: onClose,
      "data-testid": t5
    }];
    $[9] = onClose;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = props["data-testid"];
  const t8 = sharePresetState === SharePresetStateEnum.LOADING;
  const t9 = sharePresetState === SharePresetStateEnum.ERROR;
  let t10;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = i18n.t("page.datagrid.labels.sharePresetDialogUrl");
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = i18n.t("general.actions.copyToClipboard");
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== onCopyToClipboard) {
    t12 = [{
      title: t11,
      leftIcon: "content/copy",
      onClick: onCopyToClipboard
    }];
    $[14] = onCopyToClipboard;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== props) {
    t13 = suffixTestId("url", props);
    $[16] = props;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== shareUrl || $[19] !== t12 || $[20] !== t13) {
    t14 = <TextInput label={t10} type="text" value={shareUrl} labelActions={t12} data-testid={t13} />;
    $[18] = shareUrl;
    $[19] = t12;
    $[20] = t13;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== t14 || $[23] !== t8 || $[24] !== t9) {
    t15 = <DataStatus isLoading={t8} isError={t9}>{t14}</DataStatus>;
    $[22] = t14;
    $[23] = t8;
    $[24] = t9;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== onClose || $[27] !== t15 || $[28] !== t6 || $[29] !== t7) {
    t16 = <Dialog isOpen={true} onClose={onClose} title={t3} buttons={t6} data-testid={t7}>{t15}</Dialog>;
    $[26] = onClose;
    $[27] = t15;
    $[28] = t6;
    $[29] = t7;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  return t16;
}